import { useQueryClient as o, useMutation as l, useQuery as y, useInfiniteQuery as d } from "@tanstack/react-query";
import a from "./chat.api.js";
import { teachurKeys as u } from "../../constants/teachurKeys.js";
import { useMemo as h } from "react";
const C = (e, t) => y({
  queryKey: u.chat.list(),
  queryFn: async () => (await a.getAll(e)).data,
  ...t
}), K = (e, t) => y({
  queryKey: u.chat.detail(e),
  queryFn: async () => (await a.getOne(e)).data,
  enabled: !!e && !isNaN(e),
  ...t
}), M = (e) => {
  const t = o();
  return l({
    mutationFn: async (r) => (await a.create(r)).data,
    onSuccess: (r, n, s) => {
      var c;
      t.invalidateQueries({ queryKey: u.chat.list() }), (c = e == null ? void 0 : e.onSuccess) == null || c.call(e, r, n, s);
    },
    ...e
  });
}, w = (e, t) => {
  const r = o();
  return l({
    mutationFn: async (n) => (await a.createMessage(e, n)).data,
    onSuccess: (n, s, c) => {
      var i;
      r.invalidateQueries({ queryKey: u.chat.detail(e) }), r.invalidateQueries({ queryKey: u.chat.list() }), (i = t == null ? void 0 : t.onSuccess) == null || i.call(t, n, s, c);
    },
    ...t
  });
}, F = (e) => y({
  queryKey: [...u.users.list(), "students"],
  queryFn: async () => (await a.getStudents()).data,
  ...e
}), S = (e) => y({
  queryKey: [...u.users.list(), "teachers"],
  queryFn: async () => (await a.getTeachers()).data,
  ...e
}), G = (e) => {
  const t = (e == null ? void 0 : e.limit) || 30, r = d({
    queryKey: ["chat-users", e == null ? void 0 : e.searchTerm, t],
    queryFn: async ({ pageParam: s = 0 }) => (await a.getUsers({
      searchTerm: e == null ? void 0 : e.searchTerm,
      limit: t,
      offset: s
    })).data,
    getNextPageParam: (s) => {
      if (s.pagination.hasMore)
        return s.pagination.offset + s.pagination.limit;
    }
  }), n = h(() => r.data ? r.data.pages.flatMap((s) => s.data) : [], [r.data]);
  return {
    ...r,
    users: n,
    hasMore: r.hasNextPage
  };
};
export {
  M as useCreateChatMutation,
  w as useCreateMessageMutation,
  K as useGetChatQuery,
  G as useGetChatUsersQuery,
  C as useGetChatsQuery,
  F as useGetStudentsQuery,
  S as useGetTeachersQuery
};
